 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"icons/icon-merchant-svg":"icons/icon-merchant-svg","icons/icon-mundi-svg":"icons/icon-mundi-svg","icons/icon-payment_methods-2_credit_cards-svg":"icons/icon-payment_methods-2_credit_cards-svg","icons/icon-payment_methods-apple_pay-svg":"icons/icon-payment_methods-apple_pay-svg","icons/icon-payment_methods-bank_transfer-svg":"icons/icon-payment_methods-bank_transfer-svg","icons/icon-payment_methods-boleto-svg":"icons/icon-payment_methods-boleto-svg","icons/icon-payment_methods-click_to_pay-svg":"icons/icon-payment_methods-click_to_pay-svg","icons/icon-payment_methods-credit_card-svg":"icons/icon-payment_methods-credit_card-svg","icons/icon-payment_methods-credit_card_and_boleto-svg":"icons/icon-payment_methods-credit_card_and_boleto-svg","icons/icon-payment_methods-debit_card-svg":"icons/icon-payment_methods-debit_card-svg","icons/icon-payment_methods-google_pay-svg":"icons/icon-payment_methods-google_pay-svg","icons/icon-payment_methods-pix-svg":"icons/icon-payment_methods-pix-svg","icons/icon-payment_methods-voucher-svg":"icons/icon-payment_methods-voucher-svg","icons/icon-profile-svg":"icons/icon-profile-svg","icons/icon-review-billing-svg":"icons/icon-review-billing-svg","icons/icon-review-boleto-svg":"icons/icon-review-boleto-svg","icons/icon-review-pix-svg":"icons/icon-review-pix-svg","icons/icon-review-recipient-svg":"icons/icon-review-recipient-svg","icons/icon-review-shipping-svg":"icons/icon-review-shipping-svg","icons/icon-review-user-svg":"icons/icon-review-user-svg","icons/icon-success-Info-svg":"icons/icon-success-Info-svg","icons/icon-success-success-svg":"icons/icon-success-success-svg"}[chunkId]||chunkId) + "." + {"0":"d102ddd234fee4fc0791","1":"82939916f6f908e59122","2":"39fa1a43ba001a08ed05","3":"020464342d7cabacf6da","4":"74c97529fca13e1239e2","5":"9afb384292078082bfe3","6":"e69ff2d22c652defbef3","7":"72259a805a57946390b3","8":"3fbf72f4b25505d612de","9":"a0892db53fce3266fe1b","10":"e105d3e7a6e8025fddc6","11":"e6b9e8e9d72ce5c9ab85","12":"3cb2b59692e2afc0b174","13":"1db00c7198e6670df48f","icons/icon-merchant-svg":"6b28c58d9fadb504c6e5","icons/icon-mundi-svg":"feca6cb6b08a0bf0fa66","icons/icon-payment_methods-2_credit_cards-svg":"092970d668778bd44c53","icons/icon-payment_methods-apple_pay-svg":"65e60c4f60b7f5a5e0e5","icons/icon-payment_methods-bank_transfer-svg":"fe6d7edfbf0490a3219a","icons/icon-payment_methods-boleto-svg":"579861f5c2783e5266b2","icons/icon-payment_methods-click_to_pay-svg":"2c26a7a27fd31f133d0c","icons/icon-payment_methods-credit_card-svg":"7d0bfd4c20f88eea715f","icons/icon-payment_methods-credit_card_and_boleto-svg":"7bd8fefac5f0a5e3f4d5","icons/icon-payment_methods-debit_card-svg":"000cf67329e364a412d7","icons/icon-payment_methods-google_pay-svg":"b9740c57625df2fde1e0","icons/icon-payment_methods-pix-svg":"c3e50c3daef0bf0c0238","icons/icon-payment_methods-voucher-svg":"cfac9f04ba0322e8d8f5","icons/icon-profile-svg":"45d379c423d3d02e7ee6","icons/icon-review-billing-svg":"34ae2772361f7c708d54","icons/icon-review-boleto-svg":"86dc97ed376d255b5e45","icons/icon-review-pix-svg":"c6c45ef22a1ed92d3746","icons/icon-review-recipient-svg":"86968060d9ee2d6abb82","icons/icon-review-shipping-svg":"ad9e3254ed4597103c9c","icons/icon-review-user-svg":"82c3807570b45bdc295e","icons/icon-success-Info-svg":"d2d1c250ef87ba92640a","icons/icon-success-success-svg":"77c8229c9627816c550c"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
